import { CommonModule, Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { AppComponent } from '../../app.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-submenu]',
  template: `
    <ng-template
      ngFor
      let-child
      let-i="index"
      [ngForOf]="root ? item : item.items">
      <li
        [ngClass]="{ 'active-menuitem': isActive(i) }"
        (mouseleave)="onCloseDropdown()"
        [class]="child.badgeStyleClass"
        style="cursor: pointer; font-size: 12px">
        @if (child.target) {
          <a
            [href]="child.url || '#'"
            [attr.tabindex]="!visible ? '-1' : null"
            [attr.target]="child.target"
            (mouseenter)="onMouseEnter(i)"
            class="ripplelink">
            <span class="menuitem-text">{{ child.label }}</span>
          </a>
        }
        @if (
          !child.routerLink && !child.target && !child.routerLinkActiveOptions
        ) {
          <a
            [attr.target]="child.target"
            [attr.tabindex]="0"
            (mouseenter)="onMouseEnter(i)"
            (click)="showMyContainer = !showMyContainer"
            (keyup.enter)="showMyContainer = !showMyContainer"
            class="ripplelink">
            <span class="menuitem-text">{{ child.label }}</span>
            @if (child.items) {
              <i class="fa fa-chevron-down"></i>
            }
          </a>
        }

        @if (child.routerLink) {
          <a
            (click)="itemClick($event, child, i)"
            [routerLink]="child.routerLink"
            routerLinkActive="active-menuitem-routerlink"
            [routerLinkActiveOptions]="{ exact: true }"
            [attr.tabindex]="null"
            [attr.target]="child.target"
            (mouseenter)="onMouseEnter(i)"
            (click)="showMyContainer = false"
            class="ripplelink">
            <span class="menuitem-text">{{ child.label }}</span>
            @if (child.items) {
              <i class=" layout-submenu"></i>
            }
            @if (child.badge) {
              <span class="menuitem-badge">{{ child.badge }}</span>
            }
          </a>
        }

        @if (!root && mega) {
          <span class="layout-megamenu-submenu-text">
            {{ child.label }}
          </span>
        }

        @if (child.items && showMyContainer) {
          <div
            class="layout-submenu-container layout-submenu-list"
            [ngClass]="{ 'layout-submenu-megamenu-container': child.mega }"
            [ngStyle]="{ padding: isActive(i) ? '' : '0' }">
            @if (showMyContainer && i === currentIndex) {
              <ul
                app-submenu
                [item]="child"
                class="layout-submenu"
                [ngClass]="{ 'layout-megamenu': child.mega }"
                [mega]="child.mega"></ul>
            }
          </div>
        }
      </li>
    </ng-template>
  `,
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class SubMenuComponent {
  showMyContainer = false;

  @Input() item!: any;
  @Input() root!: boolean;
  @Input() visible!: boolean;
  @Input() mega!: boolean;

  _reset!: boolean;
  _parentActive!: boolean;
  activeIndex!: number;
  currentIndex!: number;

  constructor(
    public app: AppComponent,
    public router: Router,
    public location: Location,
    public appMenu: AppMenuComponent
  ) {}

  itemClick(event: Event, item: MenuItem, index: number): boolean {
    if (this.root) {
      this.app.menuHoverActive = !this.app.menuHoverActive;
      event.preventDefault();
    }

    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    if (item.routerLink || item.items || item.command || item.url) {
      this.activeIndex = (this.activeIndex as number) === index ? -1 : index;
    }

    if (item.command && typeof item.command === 'function') {
      item.command({ originalEvent: event, item });
    }

    if (item.items || (!item.url && !item.routerLink)) {
      event.preventDefault();
    }

    if (!item.items) {
      if (!this.app.horizontal) {
        this.app.menuActive = false;
      }

      if (this.app.horizontal) {
        this.app.resetMenu = true;
      } else {
        this.app.resetMenu = false;
      }

      this.app.menuHoverActive = !this.app.menuHoverActive;
    }
    return false;
  }

  onMouseEnter(index: number): void {
    if (
      this.root &&
      this.app.menuHoverActive &&
      this.app.horizontal &&
      !this.app.isMobile() &&
      !this.app.isTablet()
    ) {
      this.activeIndex = index;
    }
    this.currentIndex = index;
  }

  onCloseDropdown(): void {
    this.showMyContainer = false;
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  @Input() get reset(): boolean {
    return this._reset;
  }

  set reset(val: boolean) {
    this._reset = val;

    if (this._reset && this.app.horizontal) {
      this.activeIndex = -1;
    }
  }

  @Input() get parentActive(): boolean {
    return this._parentActive;
  }

  set parentActive(val: boolean) {
    this._parentActive = val;

    if (!this._parentActive) {
      this.activeIndex = -1;
    }
  }
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [CommonModule, SubMenuComponent]
})
export class AppMenuComponent implements OnInit {
  @Input() reset!: boolean;
  model!: any[];

  constructor(public app: AppComponent) {}

  ngOnInit(): void {
    this.model = [
      {
        label: 'Dashboard',
        routerLink: ['/dashboard'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Program',
        routerLinkActiveOptions: false,
        items: [
          {
            label: 'MCAP',
            routerLink: ['/home'],
            routerLinkActiveOptions: true
          },
          {
            label: 'Special Investments',
            routerLink: ['/special-investments'],
            routerLinkActiveOptions: true
          },
          {
            label: 'Events',
            routerLink: ['/events'],
            routerLinkActiveOptions: true
          },
          {
            label: 'MRPP',
            routerLink: ['/mrpp'],
            routerLinkActiveOptions: true
          }
        ]
      },
      {
        label: 'Partner Dashboard',
        routerLink: ['/partner-dashboard'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Customer Usage',
        routerLink: ['/customer-usage'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Payment Schedule',
        routerLinkActiveOptions: false,
        items: [
          {
            label: 'MCAP/Special Investments',
            routerLink: ['/payment-schedule'],
            routerLinkActiveOptions: true
          },
          {
            label: 'Events/MRPP/CSI',
            routerLink: ['/events-payment-schedule'],
            routerLinkActiveOptions: true
          },
          {
            label: 'MSAIP',
            routerLink: ['/msaip-milestone2-payment-schedule'],
            routerLinkActiveOptions: true
          }
        ]
      },
      {
        label: 'Accelerator Dashboard',
        url: environment.acceleratorDashboardUrl,
        target: '_blank'
      },
      {
        label: 'Advisor Incentives Dashboard',
        routerLink: ['/advisor-incentives'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Admin',
        routerLink: ['/admin'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Payment Profiles',
        routerLink: ['/payment-profiles'],
        routerLinkActiveOptions: true
      },
      {
        label: 'Partner Management',
        url: environment.managementPortalUrl,
        target: '_blank'
      }
    ];
  }
}
